module.exports = __webpack_public_path__ + "static/media/bubble-4.6a3781f2.svg";